<template lang="html">
   <div class="radio-row" :class="classes.radioRow">
      <div class="radio-content"  :class="classes.radioCol" v-for="(radio,i) in updated_options" :key="i">
         <input 
            type="radio" 
            class="radio-input"
            :name="action+name" 
            :id="name+i" 
            :value="radio.val"
            v-model="selected_item"
            @change="updateSelf($event.target.value)">
         <label class="radio-label" :for="name+i" v-html="radio.label"></label>
      </div>
   </div>
</template>

<script>
export default {
   props: {
      type: {
         default: ''
      },
      options: {
         default: function(){
            return []
         }
      },
      name: {
         default: ''
      },
      classes: {
         default: function(){
            return {
               radioRow: '',
               radioCol: '',
            }
         }
      },
      model: {
         default: ''
      },
      elClass: {
         default: 'funkyradio'
      },
      action: {
         default: ''
      }
   },
   watch:{
      model(oldVal,newVal){
         this.selected_item = newVal
      },
      options(oldVal,newVal){
         this.updateOptions()
      }
   },
   data () {
      return {
         selected_item: '',
         id: '',
         updated_options: []
      }
   },
   methods: {
      updateSelf(model) {
         this.$emit("input", this.selected_item);
      },
      updateOptions(){
         this.updated_options = []

         for (let i = 0; i < this.options.length; i++) {
            const opt = this.options[i];
            opt.id = Math.round(Math.random() * 100000)
            
            this.updated_options.push(opt)
         }
      }
   },
   mounted(){
      this.updateOptions()
   }
}
</script>